module.exports = __webpack_public_path__ + "static/media/bsm-logo-single.83dc2a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bsm-logo-single.png
// module id = 282
// module chunks = 0